<template>
  <div id="modalVerChange" class="modal fade" data-backdrop="false">
		<div class="modal-backdrop">
    <div class="modal-dialog modal-dialog-vertical-center modal-md">
      <div class="modal-content bd-0 tx-14">
        <div class="modal-body pd-25">
          <div class="alert-wrap d-flex align-items-center justify-content-center">
            <i class="iconfont icon-info tx-primary"></i>
            <p>您当前访问的页面已更新，请刷新页面重新加载。</p>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold"
            @click="reLoadPage"
          >刷新页面</button>
        
				</div>
			</div>
		</div>
		</div>
  </div>
</template>

<script>
export default {
  methods: {
    reLoadPage() {
      location.reload();
    }
  }
};
</script>

<style scoped>
.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
    outline: 0;
	width: 37.5rem;
}
.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px;
    border-bottom: 1px solid #e9ecef;
}
.modal-header h6{
	margin: 0;
	color: #343a40;
}
.close {
    float: right;
    font-size: 1.3125rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}
.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 25px;
}
.align-items-center {
    align-items: center!important;
}
.justify-content-center {
    justify-content: center!important;
}
.d-flex {
    display: flex!important;
}
.alert-wrap i{
    margin-right: 15px;
    font-size: 54px;
  }
.alert-wrap p{
    margin: 0;
    font-size: 18px;
  }
.modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 1px solid #e9ecef;
}
.justify-content-center {
    justify-content: center!important;
}
.modal-footer .btn{
	height: auto;
}
</style>


